import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
export const ApplicationLauncherText = (_a) => {
    var { className = '', children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement("span", Object.assign({ className: css('pf-c-app-launcher__menu-item-text', className) }, props), children));
};
ApplicationLauncherText.displayName = 'ApplicationLauncherText';
//# sourceMappingURL=ApplicationLauncherText.js.map